import React from "react";
import { useNavigate } from "react-router-dom";
import "./adminhome.css";

const AdminHome = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("email");
    navigate("/admin/login");
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const adminEmail = localStorage.getItem("email") || "Admin";

  return (
    <div className="admin-home">
      {/* Header with admin info */}
      <div className="admin-header">
        <span className="welcome-message">Welcome, {adminEmail}</span>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>

      {/* Main Content */}
      <h5>Admin Dashboard</h5>
      <div className="admin-options">
        <button
          className="admin-option-btn"
          onClick={() => handleNavigation("/admin/dashboard")}
        >
          Reports
        </button>
        <button
          className="admin-option-btn"
          onClick={() => handleNavigation("/admin/uploadusers")}
        >
          Upload Users
        </button>
      </div>
    </div>
  );
};

export default AdminHome;
